
import { h } from "preact";
import { RoutableProps } from "preact-router";
import { LabelPreview } from "../../LabelPreview";
import { useMemo, useState } from "preact/hooks";
import { FileInput } from "../../../../components/FileInput";
import { route } from "../../../../App";
import { addLabelFile, getLabelFiles, LabelData } from "../../../../api/label-creator";

import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../../components/Snackbar";
import { useCommand } from "../../../../hooks";

export function findExistingFile(files: LabelData, path: string) {
    const parts = path.split("/").filter(v => v);
    let current = files;

    for (let i = 0; i < parts.length; i++) {
        current = current[parts[i]];

        if (!current) {
            return false;
        }
    }

    return true;
}

export function LabelFilesEditPage(props: RoutableProps & { labelPath?: string, existingLabel?: string }) {
    const [label, setLabel] = useState(null as File | null)
    const [labelSvg, setLabelSvg] = useState("");
    const [path, setPath] = useState(props.existingLabel ? props.existingLabel : props.labelPath ? props.labelPath + "/" : "");
    const [labelFiles, setLabelFiles] = useState(null as LabelData | null);
    const [isAddingFile, setIsAddingFile] = useState(false);
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();

    useMemo(() => {
        getLabelFiles().then(v => setLabelFiles(v));
    }, []);

    if (!labelFiles) {
        return <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
            <div>Pobieranie danych...</div>
            <div class="loader"></div>
        </div>;
    }

    return <div class="label-files-new-page">
        <Snackbar doShow={showSnackbarCommand}/>
        <h1>{props.existingLabel ? "Zamień plik naklejki" : "Dodaj nowy plik naklejki"}</h1>
        <div style="display: flex">
            <div class="file-upload paper">
                <h2>Wrzuć plik naklejki</h2>
                <div>
                    <label>
                        <span style="width: 80px; text-align: right; margin-right: 5px;">Plik naklejki:</span>
                        <FileInput style="width: 400px;" accept=".svg" onChange={(files) => {
                            setLabel(files[0] ?? null);

                            const reader = new FileReader();
                            reader.onload = () => {
                                setLabelSvg(reader.result as string);
                            }
                            reader.readAsText(files[0]);
                        }}/>
                    </label>
                </div>
                <div style="margin-top: 10px;">
                    <label>
                        <span style="width: 80px; text-align: right; margin-right: 5px;">Ścieżka:</span>
                        {props.existingLabel
                            ? <input style="width: 400px; background: #353535; color: #8f8f8f" value={path} disabled/>
                            : <input style="width: 400px" value={path} onChange={(e) => setPath(e.currentTarget.value)}/>
                        }
                    </label>
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #afafaf">
                    <div>Ścieżka składa się z nazwy pliku i opcjonalnych nazw folderów oddzielonych znakiem '/'</div>
                    <div style="margin-top: 3px">Wszystkie nazwy naklejki powinny kończyć się rozszerzenim '.svg'.</div>
                    <div style="margin-top: 3px">Przykład: Folder1/Folder2/Nazwa_Naklejki.svg</div>
                </div>
                <div style="margin-top: 10px;">
                    <span class="tooltip tooltip-warning" {
                        ...(!label ? { "data-tooltip": "Nie wybrano pliku naklejki" }
                            : !path || path.endsWith("/") ? { "data-tooltip": "Podana ścieżka jest nieprawidłowa"}
                            : !props.existingLabel && findExistingFile(labelFiles, path) ? { "data-tooltip": "Plik o podanej nazwie już istnieje" }
                            : !path.endsWith(".svg") ? { "data-tooltip": "Nazwa pliku musi kończyć się rozszerzeniem '.svg'"}
                            : {}
                        )
                    }>
                        <button
                            class={!labelFiles
                                || !label
                                || !path
                                || path.endsWith("/")
                                || !path.endsWith(".svg")
                                || (!props.existingLabel && findExistingFile(labelFiles, path))
                                || isAddingFile
                                ? "disabled" : ""
                            }
                            onClick={async () => {
                                if (!label) {
                                    return;
                                }

                                setIsAddingFile(true);

                                try {
                                    await addLabelFile(path, label);
                                }
                                catch(ex) {
                                    console.error(ex);
                                    showSnackbarCommand.run("Nie udało się " + (props.existingLabel ? "zamienić" : "dodać") + " naklejki.", "error", "error", 2000);
                                    setIsAddingFile(false);
                                    return;
                                }

                                route("/label/files?successMessage=" + encodeURIComponent("Naklejka dodana prawidłowo"));
                            }}
                        >
                            {props.existingLabel ? "Zamień" : "Dodaj"}
                        </button>
                    </span>
                    <button class={"error " + (isAddingFile ? "disabled" : "")} style="margin-left: 10px;" onClick={() => history.back()}>Anuluj</button>
                </div>
                {isAddingFile ? <div style="margin-top: 10px;">
                    <div>{props.existingLabel ? "Zamienianie naklejki" : "Dodawanie naklejki..."}</div>
                    <div class="loader"/>
                </div> : null}
            </div>
            <div class="label-preview paper">
                <h2>Podgląd szablonu</h2>
                <div class="preview-container">
                    <div class="preview">
                        {label ? <LabelPreview svg={labelSvg} maxHeight={400} maxWidth={500} fonts={[
                            "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
                        ]}/> : null}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
